// extracted by mini-css-extract-plugin
export default {"mainContent":"build-system-direct_mainContent__rbMlA"};